interface SectionLabelProps {
  label: string;
  color?: "red" | "orange" | "green" | "blue";
}

const colorMap = {
  red: "bg-ticca-red/10 text-ticca-red border-ticca-red/20",
  orange: "bg-ticca-orange/10 text-ticca-orange border-ticca-orange/20",
  green: "bg-ticca-green/10 text-ticca-green border-ticca-green/20",
  blue: "bg-ticca-blue/10 text-ticca-blue border-ticca-blue/20",
};

export const SectionLabel = ({ label, color = "blue" }: SectionLabelProps) => (
  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase border ${colorMap[color]}`}>
    {label}
  </span>
);
